<template>
  <div class="min-h-screen flex flex-col" style="background-color:#f7f7f7">
    <LayoutNavbar :menu-style="'1'" class="flex items-center text-white justify-between fixed left-0 top-0 w-full bg-[linear-gradient(147.04deg,_#0077BC_0.74%,_#262772_99.61%)] shadow z-50 px-4 py-2 md:px-6 lg:px-8"/>

    <!-- Main content goes here -->
    <div class="flex-grow mt-16">
    <!-- <div class="flex-grow mt-12">  -->
      <NuxtPage :transition="pageTransition"/>
      <!-- page content -->
    </div>
    <!-- Spacer to offset fixed menu height bg-gray-100-->
    <div class="h-16"></div>
    <footer class="relative fixed bottom-0 left-0 w-full bg-white py-4  text-sm text-gray-500"
      style="border-top: 1px solid #ededed">
      <div class="flex items-center justify-center gap-2">
        <div class="flex items-center space-x-6">
          <!-- Second logo -->
          <LogoIcon class="h-6 w-auto" />
          <span class="xl:inline  lg:inline hidden sm:inline xl:hidden">© {{ new Date().getFullYear() }}. {{$t('common.default_layout.footer_company_rights_disclaimer') }}.</span>
        </div>
      </div>
      <div class="absolute right-4 top-1/2 transform -translate-y-1/2 hidden sm:block text-xs">
        <LanguageSwitcher />
      </div>
    </footer>
  </div>
  <ScrollToTop />
</template>

<script lang="ts" setup>
//console.log("mounted");

import ScrollToTop from '~/components/ScrollToTop/index.vue';
import LogoIcon from '~/assets/3a-logo-core-materials.svg';
import type { TransitionProps } from 'vue';
const route = useRoute();
const direction = useTransitionDirection();

const pageTransition = computed<TransitionProps>(() => {
  const base: TransitionProps = { mode: 'out-in' as const, name: '' } // siempre hay un transition
  if (!route.meta.slideTransition) return base // transición vacía
  return {
    name: direction.value,
    mode: 'out-in' as const
  }
})
</script>

<style>
/* Slide hacia la derecha (adelante) */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform .35s ease, opacity .35s ease;
  position: absolute; inset: 0; width: 100%;
  top: 64px; /* altura de tu navbar */
}
.slide-right-enter-from { transform: translateX(100%); opacity: 0; }
.slide-right-leave-to   { transform: translateX(-100%); opacity: 0; }

/* Slide hacia la izquierda (back) */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform .35s ease, opacity .35s ease;
  position: absolute; inset: 0; width: 100%;
  top: 64px; /* altura de tu navbar */
}
.slide-left-enter-from  { transform: translateX(-100%); opacity: 0; }
.slide-left-leave-to    { transform: translateX(100%);  opacity: 0; }

/* slide up */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
  opacity: 1;
}

/* slide down */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
  transform: translateY(0);
  opacity: 1;
}

</style>